// extracted by mini-css-extract-plugin
export default {"PuckPreview":"styles_PuckPreview__Va5kp","PuckPreview-frame":"styles_PuckPreview-frame__V4K01"};